import { Component, Input, OnInit } from '@angular/core';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-user-thumb-nail',
    templateUrl: './user-thumb-nail.component.html',
    styleUrl: './user-thumb-nail.component.scss',
    imports: [UpperCasePipe]
})
export class UserThumbNailComponent implements OnInit {
  @Input() userEmail: string = '';
  displayName = 'FN';

  ngOnInit(): void {
    if (this.userEmail) {
      const splitData: string[] = this.userEmail.includes('@') ? this.userEmail.split("@")[0].split(".") : this.userEmail.split(" ");
      this.displayName = splitData.length > 1 ? (this.userEmail.includes('@') ? splitData[1][0] + splitData[0][0] : splitData[0][0] + splitData[1][0]) : splitData[0][0];
    }
  }

}
